import { render, staticRenderFns } from "./member-selector.vue?vue&type=template&id=49f06425&scoped=true"
import script from "./member-selector.vue?vue&type=script&lang=js"
export * from "./member-selector.vue?vue&type=script&lang=js"
import style0 from "./member-selector.vue?vue&type=style&index=0&id=49f06425&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f06425",
  null
  
)

export default component.exports